import { findElementAll, selectedElementAll } from "../utils/element-handlers.utils";
import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
import { swiperSliderTabindexFix } from "../utils/swiper-utils";

function CarouselComponent(carouselElement: HTMLElement) {
    const carouselItemsCount = findElementAll('.n-carousel-item', carouselElement).length;

    if (carouselItemsCount === 0) return;

    const swiper = new Swiper(carouselElement, {
        loop: carouselItemsCount > 1,
        slidesPerView: 1,
        breakpoints: {
            768: {
                loop: carouselItemsCount > 2,
                slidesPerView: Math.min(2, carouselItemsCount),
            },
            992: {
                loop: carouselItemsCount > 3,
                slidesPerView: Math.min(3, carouselItemsCount),
            },
        },
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            pauseOnMouseEnter: true,
        },
        pagination: {
            el: '.swiper-pagination',
            bulletClass: 'n-carousel-pagination-bullet',
            bulletActiveClass: 'n-carousel-pagination-bullet-active',
            clickable: true,
            renderBullet: function (index, className) {
                return `<button aria-label="Go to carousel item ${index + 1}" class="${className}"></button>`
            },
        },
        modules: [
            Autoplay,
            Pagination,
        ],
    });

    const maxSlidesCount = swiper.slides.length;
    const initialSlidesPerView = swiper.params.slidesPerView;

    if (typeof initialSlidesPerView === 'number') {
        checkBullets(initialSlidesPerView);

        swiper.on('breakpoint', (swiperHandler, breakpointParams) => {
            const currentSlidesPerView = breakpointParams.slidesPerView;

            if (typeof currentSlidesPerView === 'number') {
                checkBullets(currentSlidesPerView);
            }
        });
    }

    swiperSliderTabindexFix(swiper);

    function checkBullets(visibleSlidesCount: number) {
        swiper
            .pagination
            .el
            .classList
        [visibleSlidesCount < maxSlidesCount ? 'remove' : 'add']
            ('n-carousel-pagination-disabled');
    }
}

export default function initCarouselComponent() {
    selectedElementAll('.n-carousel', CarouselComponent);
}
